/// <reference path="../../../../node_modules/@1js/office-online-strings/en-US/transcription-strings.d.ts" />
import Dispatcher from '../../dispatcher';
import { FailureActionTypes, FailureContinuation } from '../../common/enums/failureEnums';

export function SetFailureContinuation(continuation: FailureContinuation) {
  Dispatcher.dispatch({
    type: FailureActionTypes.SetFailureContinuationAction,
    payload: continuation
  });
}

export function SetFailureReason(failureReason: string) {
  Dispatcher.dispatch({
    type: FailureActionTypes.SetFailureReasonAction,
    payload: failureReason
  });
}